import { createContext, useContext } from "react"

/**
 * Provides the DOM element that portal-rendered overlays (popovers, tooltips)
 * should render into.
 *
 * Default: document.body — works for standalone usage.
 *
 * Inside a <dialog> modal: provide dialogRef.current so overlays render inside
 * the dialog's top-layer stacking context (where they appear above the backdrop).
 */
const PortalTargetContext = createContext<Element | null>(null)

export const PortalTargetProvider = PortalTargetContext.Provider

export function usePortalTarget(): Element {
  return useContext(PortalTargetContext) ?? document.body
}
